// Campo del balance hídrico (TOTAL 1-6, SUMA, BALANCE DIARIO...) de 113/114: muestra el valor CALCULADO desde las filas horarias, de solo
// lectura. Solo se puede escribir encima si la enfermera lo pide explícitamente ("Escribir a mano"): entonces lo escrito (`manual`) manda sobre
// el cálculo hasta que pulse "Volver al cálculo". En modo manual, vaciar el campo mientras se teclea NO revierte al cálculo (el estado de edición
// es local); si se guarda vacío, el PDF imprime el valor calculado.
// Un campo que no se puede derivar de una sola hoja (balance total/global, acumulado de varios días) se muestra como campo normal.
import type { JSX } from 'react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';

export interface CampoBalanceHidricoProps {
  readonly id: string;
  readonly label: string;
  /** Lo que la enfermera sobrescribió (`''` = sin sobrescribir). */
  readonly manual: string;
  /** Valor efectivo: `manual` si hay, o el cálculo (puede ser `''` si aún no hay datos). */
  readonly efectivo: string;
  /** `false` para el balance acumulado (no se calcula). */
  readonly calculable: boolean;
  readonly onChange: (manual: string) => void;
}

export function CampoBalanceHidrico({ id, label, manual, efectivo, calculable, onChange }: CampoBalanceHidricoProps): JSX.Element {
  const { t } = useTranslation();
  const [editando, setEditando] = useState(() => manual.trim() !== '');
  if (!calculable) {
    return (
      <div className="flex flex-col gap-1">
        <Label htmlFor={id}>{label}</Label>
        <Input id={id} value={manual} onChange={(e) => onChange(e.target.value)} />
      </div>
    );
  }
  return (
    <div className="flex flex-col gap-1">
      <Label htmlFor={id}>{label}</Label>
      <Input id={id} value={editando ? manual : efectivo} readOnly={!editando} onChange={(e) => onChange(e.target.value)} />
      <p className="text-xs text-hce-muted">
        {editando ? t('formularios.uci.balance.manual') : t('formularios.uci.balance.calculado')}
        {' · '}
        {editando ? (
          <button
            type="button"
            className="underline"
            onClick={() => {
              setEditando(false);
              onChange('');
            }}
          >
            {t('formularios.uci.balance.volverAlCalculo')}
          </button>
        ) : (
          <button
            type="button"
            className="underline"
            onClick={() => {
              setEditando(true);
              onChange(efectivo);
            }}
          >
            {t('formularios.uci.balance.escribirAMano')}
          </button>
        )}
      </p>
    </div>
  );
}
